export default __webpack_public_path__ + "static/media/design-center-img-3.9773e662.png";